import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils';
import { useLocation } from 'react-router-dom';

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: 'navy',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ItemWiseSaleReortRegisterPdf = ({ data }) => {
  console.log('ItemWiseSaleReortRegisterPdf Data:', data);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refIdRaw = queryParams.get('refId');

  let refId = {};
  refId = JSON.parse(refIdRaw); // Now refId is an object

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Item Wise Sale Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            {/* Hospital logo */}
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />

            {/* Date range */}
            <Text style={{ fontSize: '8px' }} content={`From Date : ${refId.from_date} To Date : ${refId.to_date}`} />

            {/* Table headers */}
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr" />
                <Text style={styles.columnHeader} content="Bill No." />
              <Text style={styles.columnHeader} content="Product Name" />
              <Text style={styles.columnHeader} content="Total Qty" />
              <Text style={styles.columnHeader} content="Rate" />
              <Text style={styles.columnHeader} content="Total Amount" />
            </View>

            {/* Display the sorted product data */}
            {data?.retailsaleposdata?.length > 0 && (
              <>
                <Text style={{ fontSize: '8px' }} content={'Retail Sale Pos'} />
                {data.retailsaleposdata.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={styles.columnContent} content={index + 1} />
                    <Text style={styles.columnContent} content={item.inv_no} />
                    <Text style={styles.columnContent} content={item.productName} />
                    <Text style={styles.columnContent} content={item.qty} />
                     <Text style={styles.columnContent} content={item.mrp} />
                    <Text style={styles.columnContent} content={Number(item.amount).toFixed(2)}/>
                  </View>
                ))}
              </>
            )}

            {data?.retailsalereturndata?.length > 0 && (
              <>
                <Text style={{ fontSize: '8px' }} content={'Retail Sale Return'} />
                {data.retailsalereturndata.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={styles.columnContent} content={index + 1} />
                    <Text style={styles.columnContent} content={item.ret_no} />
                    <Text style={styles.columnContent} content={item.productName} />
                    <Text style={styles.columnContent} content={item.qty} />
                    <Text style={styles.columnContent} content={Number(item.amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={Number(item.gst_amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={Number(item.mrp).toFixed(2)} />
                    <Text style={styles.columnContent} content={Number(item.billAmount).toFixed(2)} />
                  </View>
                ))}
              </>
            )}

            {data?.indentmedicineissuedata?.length > 0 && (
              <>
                <Text style={{ fontSize: '8px' }} content={'Indent Medicine Issue'} />
                {data.indentmedicineissuedata.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={styles.columnContent} content={index + 1} />
                     <Text style={styles.columnContent} content={item.issue_no} />
                    <Text style={styles.columnContent} content={item.productName} />
                    <Text style={styles.columnContent} content={item.qty} />
                    <Text style={styles.columnContent} content={Number(item.amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={Number(item.gst_amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={(item.mrp)} />
                    <Text style={styles.columnContent} content={Number(item.billAmount).toFixed(2)} />
                  </View>
                ))}
              </>
            )}

            {data?.indentMedicineReturnData?.length > 0 && (
              <>
                <Text style={{ fontSize: '8px' }} content={'Indent Medicine Return'} />
                {data.indentMedicineReturnData.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={styles.columnContent} content={index + 1} />
                     <Text style={styles.columnContent} content={item.issue_no} />
                    <Text style={styles.columnContent} content={item.productName} />
                    <Text style={styles.columnContent} content={item.qty} />
                    <Text style={styles.columnContent} content={Number(item.amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={Number(item.gst_amount).toFixed(2)} />
                    <Text style={styles.columnContent} content={(item.mrp)} />
                    <Text style={styles.columnContent} content={Number(item.billAmount).toFixed(2)} />
                  </View>
                ))}
              </>
            )}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default ItemWiseSaleReortRegisterPdf;
